import { Component, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { localStorageService } from 'src/app/services/localstorage.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
    selector: 'app-hipaa-closure',
    templateUrl: './hipaa-closure.component.html',
    styleUrl: './hipaa-closure.component.scss',
})
export class HipaaClosureComponent {
  readonly consent = signal<any>(undefined);
  readonly patient_name = signal('');
  readonly practice_name = signal('');
  readonly doctor_name = signal('');
  readonly doctor_practice_name = signal('');
  readonly currency_data = signal<any>(undefined);
  country_data: any;

  constructor( private _activated: ActivatedRoute, public _apiService: ApiService, public _shared: SharedService) { }

  // userInfo = JSON.parse(this._local.customGetItem('user'));

  ngOnInit() {
    this._activated.queryParams.subscribe((params: any) => {
      this.patient_name.set(params['patient_name'] || '');
      if (this.isOpen) {
        this.getOpenBusiness(params['contract_patient_token']);
      }
    })

    // The open route has no session to ask: the business is looked up by token.
    if (this.isOpen) {
      return;
    }
    this.getHippaDetails()
  }

  /**
   * The public /support/hipaa route, outside the signed-in layout. It has no
   * login, so it cannot read the profile the signed-in page fills itself from:
   * `patient_name` and `contract_patient_token` come on the link, and the
   * business is looked up from the token — the same customer-facing token the
   * proposal links already carry, so nothing sequential is exposed.
   */
  private get isOpen(): boolean {
    return !!this._activated.snapshot.data['open'];
  }

  /**
   * The business behind a contract, from an endpoint that needs no login.
   *
   * `auth/get_contract_business_details?contract_patient_token=` answers
   * `{ is_error: 0, business_name }`. A failed or empty answer leaves the
   * business as blank lines, the way the signed-in page does when it has none.
   */
  private getOpenBusiness(token: string | undefined): void {
    // The page prints a $25.00 returned-payment charge; with no profile there is
    // no currency to read, and an empty symbol printed it as a bare number.
    this.currency_data.set({ display_logo: '$' });
    if (!token) { return; }

    this._apiService.api({ contract_patient_token: token }, 'auth/get_contract_business_details', 'get', false)
      .subscribe({
        next: (response: any) => {
          if (response?.is_error) { return; }
          const name = response?.business_name || response?.data?.business_name || '';
          this.practice_name.set(name);
          this.doctor_name.set(name);
          this.doctor_practice_name.set(name);
        },
        error: () => { /* blank lines stand in for the business */ },
      });
  }

  public getHippaDetails() {
    this._apiService.api('' , `profile/get_profile`, "get" )
      .subscribe(response => {
        if (response.is_error) {
        } else {
          this.consent.set(response.profile);
          this.currency_data.set(response?.country_currency_info?.currency?.length ? response?.country_currency_info?.currency[0] : null);
          // The doctor_profile fallbacks come from live: get_profile does not
          // always answer under `profile`, and without them the HIPAA closure
          // rendered with no practice or doctor name on it.
          this.practice_name.set(response?.profile?.practice_name || response?.doctor_profile?.practice_name || '');
          this.doctor_name.set(response?.profile?.doctor_name || response?.doctor_profile?.doctor_name || '');
          let name = '';
          const doctor_title = response?.profile?.doctor_title || response?.doctor_profile?.doctor_title;
          const doctor_name = response?.profile?.doctor_name || response?.doctor_profile?.doctor_name;
          const practice_name = response?.profile?.practice_name || response?.doctor_profile?.practice_name;
          if(doctor_title){
            name += doctor_title;
          }
          if(doctor_name){
            name += doctor_name;
          }
          else if(practice_name){
            name += practice_name;
          }

          // `doctor_name` above already falls back to doctor_profile.
          this.doctor_practice_name.set(doctor_name || '');
          console.log(this.doctor_name());
        }
      });
  }
}
